<template>
    <section class="developer-news-list-section mgt-5 mgb-5" id="developerNewsList">
<!--        <div class="section-loading-screen" v-if="showLoading">-->
<!--            <div class="section-loading-bubbles">-->
<!--                <span class="d1"></span>-->
<!--                <span class="d2"></span>-->
<!--                <span class="d3"></span>-->
<!--                <span class="d4"></span>-->
<!--            </div>-->
<!--        </div>-->

        <div v-for="(developerNewsOnDate, formattedCreatedOn) in developerNewsGroupedByDate"
             :key="`date-${formattedCreatedOn}`"
             class="dashboard-elements-list-stacked">
            <div class="dashboard-elements-list-stacked__date">
                {{formattedCreatedOn}}
            </div>

            <div v-for="developerNews in developerNewsOnDate"
                 :key="`developerNews-${developerNews.id}`"
                 class="pp-model-item pp-model-item-v2 pp-model-item-news pp-model-item-post">
                <div class="pp-model-item-content pp-length-flex">
                    <div class="pp-model-info pp-length-info">

                        <div class="pp-model-info-strip pp-model-info-strip-header">
                            <div class="image"
                                 :style="{ backgroundImage: 'url(' + developerNews.project.profileImage + ')' }"></div>
                            <div>

                                <a :href="developerNews.project.url" class="heading-v2">
                                    <h5 class="mb-1 pb-heading heading">
                                        {{ developerNews.project.name }}
                                    </h5>
                                </a>
                                <div class="mb-1 pb-element-location d-flex align-items-center">
                                    <i class="mr-2 fad fa-map-marker-alt"></i>
                                    <p class="font-weight-normal">
                                        {{ developerNews.project.countyName }} / {{ developerNews.project.cityName }}{{ developerNews.project.zoneName ? ' / ' + developerNews.project.zoneName : '' }}
                                    </p>
                                </div>
                                <div class="pp-model-info-strip pp-model-info-strip-date">
                                    <p class="small small-13">{{developerNews.formattedUpdatedOn}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="pp-model-info-strip">
                            <div class="pp-model-info-text pp-model-info-text--font-14 wysiwyg pp-model-info-truncate-text">
                                <div class="original-text" v-html="developerNews.news"></div>
                            </div>
                        </div>
                    </div>
                    <div :class="{
                            'js-gallery': true,
                            'pp-model-picture-v2': true,
                            'oneItem': developerNews.images.length + developerNews.videos.length === 1,
                            'twoItems': developerNews.images.length + developerNews.videos.length === 2,
                            'threeItems': developerNews.images.length + developerNews.videos.length === 3,
                            'fourItems': developerNews.images.length + developerNews.videos.length === 4,
                            'fiveItems': developerNews.images.length + developerNews.videos.length >= 5,
                         }"
                         v-if="developerNews.images.length || developerNews.videos.length">
                        <a
                            v-for="(image, index) in developerNews.images"
                            :key="`image-${index}`"
                            :href="image.large"
                            :data-exthumbimage="image.thumb"
                            :style="{ backgroundImage: 'url(' + image.large + ')' }"
                            :data-remaining="`${developerNews.images.length + developerNews.videos.length - index - 1}`"
                            class="pp-model-picture-v2-item"
                        ></a>
                        <a
                            v-for="(videoEmbedUrl, index) in developerNews.videos"
                            :key="`video-${index}`"
                            :href="videoEmbedUrl"
                            :data-remaining="`${developerNews.videos.length - index - 1}`"
                            class="pp-model-picture-v2-item video-item"
                        >
                            <object class="video" :data="videoEmbedUrl"></object>
                        </a>
                    </div>
                    <div class="pp-model-buttons">
                        <a :href="developerNews.project.newsfeedUrl" class="general-btn attention-btn">
                            <span>Noutati proiect</span>
                        </a>

                        <a href="javascript:void(0)" class="round-btn"
                           @click="openPublicContactModalProject(developerNews.project)">
                            <i class="fad fa-address-card"></i>
                            <span>Contact</span>
                        </a>
                        <a :href="developerNews.project.url" class="general-btn ghost-btn">
                            <span>Vezi proiect</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <public-contact-modal-project></public-contact-modal-project>
    </section>
</template>

<script>
import PublicContactModalProject from "./partials/PublicContactModalProject";

export default {
    name: "PublicDeveloperNewsList",
    components: { PublicContactModalProject},
    props: ["county", "cityIdList"],
    data() {
        return {
            showLoading: false,
            developerNewsList: [],
            urlParams: {},
            sectionBottomScrollPositionRelativeToWindowBottom: 10000000,
            page: 1,
        };
    },
    created: function () {},
    mounted() {
        this.urlParams = window.getAllUrlParams();
        this.page = parseInt(this.urlParams.page);
        this.page = (isNaN(this.page) || this.page < 1) ? 1 : this.page;
        window.addEventListener('scroll', this.handleScroll);
        this.fetchDeveloperNews();
    },
    computed: {
        developerNewsGroupedByDate(){
            let output = {}
            for(let i in this.developerNewsList){
                let developerNews = this.developerNewsList[i];

                if (!Object.prototype.hasOwnProperty.call(output, developerNews.formattedCreatedOn)) {
                    output[developerNews.formattedCreatedOn] = [];
                }

                output[developerNews.formattedCreatedOn].push(developerNews);
            }
            return output
        }
    },

    methods: {
        async fetchDeveloperNews() {
            let vm = this;
            console.log('fetchDeveloperNews', vm.page);
            // don't fetch while fetching
            if (vm.showLoading) {
                return;
            }

            vm.showLoading = true;
            let params = this.buildParams();
            params["page"] = vm.page;
            await window.axios
                .get("/ajax/newsfeed/developer-news", {
                    params: Object.assign({}, params),
                })
                .then(function (response) {
                    if (vm.developerNewsList.length > 0) {
                        vm.developerNewsList = vm.developerNewsList.concat(response.data.data.developerNewsList);
                    } else {
                        vm.developerNewsList = response.data.data.developerNewsList;

                        let lastDeveloperNew = vm.developerNewsList.length ? vm.developerNewsList[0] : null;
                        window.saveLocalLastDeveloperNewsTimestamp(lastDeveloperNew ? lastDeveloperNew.createdOnTimestamp : null)
                    }

                    if (vm.page === 1) {
                        delete vm.urlParams.page;
                    } else {
                        vm.urlParams.page = vm.page;
                    }
                    vm.updateQueryStringParam();
                    vm.initGallery();
                    vm.showLoading = false;
                    vm.page++;
                })
                .catch(function () {
                    vm.showLoading = false;
                });
        },
        buildParams() {
            let params = [];
            params["county"] = this.county.id;
            params["cityIdList"] = this.cityIdList;
            return params;
        },
        updateQueryStringParam() {
            let baseUrl = [
                location.protocol,
                "//",
                location.host,
                location.pathname,
            ].join("");
            let filtered = Object.entries(this.urlParams).reduce(
                (a, [k, v]) => (v ? ((a[k] = v), a) : a),
                {}
            );
            let params = "?" + $.param(Object.assign({}, filtered), true);
            if (params === "?") {
                params = "";
            }
            window.history.replaceState({}, "", baseUrl + params);

            // update canonical url
            if (filtered.page === 1) {
                delete filtered.page;
            }
            params = "?" + $.param(Object.assign({}, filtered), true);
            if (params === "?") {
                params = "";
            }

            document.getElementById('seoMetaCanonicalUrl')
                .setAttribute('href', baseUrl + params);
        },
        handleScroll () {
            let vm = this;
            let section = document.getElementById("developerNewsList");
            let sectionRect = section.getBoundingClientRect();
            // console.log(window.innerHeight, section.getBoundingClientRect());
            let previousPosition = vm.sectionBottomScrollPositionRelativeToWindowBottom;
            vm.sectionBottomScrollPositionRelativeToWindowBottom = sectionRect.bottom - window.innerHeight;

            let isScrollingDown = previousPosition > vm.sectionBottomScrollPositionRelativeToWindowBottom;
            let isCloseToBottom = vm.sectionBottomScrollPositionRelativeToWindowBottom < 500;
            let isBeyondBottom = vm.sectionBottomScrollPositionRelativeToWindowBottom < 0;
            if (isScrollingDown && isCloseToBottom && !isBeyondBottom) {
                vm.fetchDeveloperNews();
            }
        },
        initGallery() {
            setTimeout(function () {
                $('.js-gallery').lightGallery({
                    thumbnail: true,
                    exThumbImage: 'data-exthumbimage'
                });

                window.truncatePostContent('.pp-model-info-truncate-text', 140, 215, 300, 390, 220);
            }, 500);
        }
    },
};
</script>